export default __webpack_public_path__ + "static/media/news56.369b74eb.jpg";